const KB_GROUP_ID_KEY = 'kbGroupId';
export const KB_GROUP_ID_CHANGE_EVENT = 'kb-group-id-change';

export const getKbGroupId = () => {
  if (typeof window === 'undefined') return null;
  const fromQuery = new URLSearchParams(window.location.search).get('group_id');
  if (fromQuery) return fromQuery;
  return sessionStorage.getItem(KB_GROUP_ID_KEY) || null;
};

export const setKbGroupId = (groupId) => {
  if (typeof window === 'undefined' || !groupId) return;
  sessionStorage.setItem(KB_GROUP_ID_KEY, groupId);
  window.dispatchEvent(
    new CustomEvent(KB_GROUP_ID_CHANGE_EVENT, { detail: groupId })
  );
};

export const clearKbGroupId = () => {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(KB_GROUP_ID_KEY);
  window.dispatchEvent(
    new CustomEvent(KB_GROUP_ID_CHANGE_EVENT, { detail: null })
  );
};
